import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UnregisteredScheduleComponent } from "./unregistered-schedule.component";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { FuseSharedModule } from "@fuse/shared.module";
import { UnregisteredScheduleService } from "./unregistered-schedule.service";
import { NgxMaskModule } from "ngx-mask";
import { UnregisteredNewModule } from "app/main/unregistered-new/unregistered-new.module";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { SelectProcedureComponent } from "./select-procedure/select-procedure.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

const routes = [
    {
        path: "unregistered-schedule",
        component: UnregisteredScheduleComponent,
    },
];

@NgModule({
    declarations: [UnregisteredScheduleComponent, SelectProcedureComponent],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        TranslateModule,
        MatButtonModule,
        FuseSharedModule,
        MatTableModule,
        MatIconModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        NgxMaskModule,
        MatAutocompleteModule,
        MatCardModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        UnregisteredNewModule,
    ],
    exports: [UnregisteredScheduleComponent],
    providers: [UnregisteredScheduleService],
})
export class UnregisteredScheduleModule {}
